module.exports = __webpack_public_path__ + "img/dalou_4_3.6cb40272.png";